export default "__VITE_ASSET__DDuW8QYu__"